module.exports = __webpack_public_path__ + "static/media/bg_4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg_4.png
// module id = 49
// module chunks = 0